import React, { useState } from 'react';
import {
  Container,
  Box,
  Card,
  CardContent,
  TextField,
  Button,
  Typography,
  Alert,
  CircularProgress,
} from '@mui/material';
import { authService } from '../services/api';

export default function Login({ onLogin }) {
  const [companyCode, setCompanyCode] = useState('');
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    if (!companyCode.trim()) {
      setError('Company code is required');
      return;
    }
    setLoading(true);

    try {
      await authService.login({ username, password, company_code: companyCode.trim().toUpperCase() });
      onLogin();
    } catch (err) {
      setError(err.message || 'Login failed');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Container maxWidth='sm'>
      <Box
        sx={{
          marginTop: 8,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
        }}
      >
        <Card sx={{ width: '100%', mt: 3 }}>
          <CardContent>
            <Typography component='h1' variant='h4' align='center' gutterBottom>
              ADM Admin Dashboard
            </Typography>
            <Typography variant='body2' align='center' color='text.secondary' paragraph>
              Electricity Meter Installation Management
            </Typography>

            {error && (
              <Alert severity='error' sx={{ mb: 2 }}>
                {error}
              </Alert>
            )}

            <Box component='form' onSubmit={handleSubmit} sx={{ mt: 1 }}>
              <TextField
                margin='normal'
                required
                fullWidth
                id='company_code'
                label='Company Code'
                name='company_code'
                placeholder='e.g. DEFAULT'
                autoComplete='organization'
                autoFocus
                value={companyCode}
                onChange={(e) => setCompanyCode(e.target.value.toUpperCase())}
                disabled={loading}
                helperText='Your company code (from your administrator)'
              />
              <TextField
                margin='normal'
                required
                fullWidth
                id='username'
                label='Username'
                name='username'
                autoComplete='username'
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                disabled={loading}
              />
              <TextField
                margin='normal'
                required
                fullWidth
                name='password'
                label='Password'
                type='password'
                id='password'
                autoComplete='current-password'
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                disabled={loading}
              />
              <Button
                type='submit'
                fullWidth
                variant='contained'
                sx={{ mt: 3, mb: 2 }}
                disabled={loading}
              >
                {loading ? <CircularProgress size={24} /> : 'Sign In'}
              </Button>
            </Box>

            <Typography variant='body2' color='text.secondary' align='center' sx={{ mt: 2 }}>
              Sign in with your company code, username and password.
            </Typography>
          </CardContent>
        </Card>
      </Box>
    </Container>
  );
}

